// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---node-modules-gatsby-theme-code-notes-src-pages-404-tsx": function componentNodeModulesGatsbyThemeCodeNotesSrcPages404Tsx() {
    return import("./../gatsby-theme-code-notes/src/pages/404.tsx"
    /* webpackChunkName: "component---node-modules-gatsby-theme-code-notes-src-pages-404-tsx" */
    );
  },
  "component---node-modules-gatsby-theme-code-notes-src-templates-note-js": function componentNodeModulesGatsbyThemeCodeNotesSrcTemplatesNoteJs() {
    return import("./../gatsby-theme-code-notes/src/templates/Note.js"
    /* webpackChunkName: "component---node-modules-gatsby-theme-code-notes-src-templates-note-js" */
    );
  },
  "component---node-modules-gatsby-theme-code-notes-src-templates-notes-js": function componentNodeModulesGatsbyThemeCodeNotesSrcTemplatesNotesJs() {
    return import("./../gatsby-theme-code-notes/src/templates/Notes.js"
    /* webpackChunkName: "component---node-modules-gatsby-theme-code-notes-src-templates-notes-js" */
    );
  },
  "component---node-modules-gatsby-theme-code-notes-src-templates-tag-page-js": function componentNodeModulesGatsbyThemeCodeNotesSrcTemplatesTagPageJs() {
    return import("./../gatsby-theme-code-notes/src/templates/TagPage.js"
    /* webpackChunkName: "component---node-modules-gatsby-theme-code-notes-src-templates-tag-page-js" */
    );
  },
  "component---node-modules-gatsby-theme-code-notes-src-templates-untagged-tag-page-js": function componentNodeModulesGatsbyThemeCodeNotesSrcTemplatesUntaggedTagPageJs() {
    return import("./../gatsby-theme-code-notes/src/templates/UntaggedTagPage.js"
    /* webpackChunkName: "component---node-modules-gatsby-theme-code-notes-src-templates-untagged-tag-page-js" */
    );
  }
};